import {baseImageUrl} from "../../../helper/ui-shared/src";

export enum PartnerName {
  FINO = "Fino",
  SC_ADVANTAGE_CLUB = "scadvantageclub",
  SC_EASY_PAY = "SCEASYPAY",
  SPICEMONEY = "scspicemoney",
  scflipkart = "scflipkart",
  SC_MEESHO = "SCMEESHO",
}

export interface PartnerDetails {
  [key: string]: {
    name?: string;
    companyName?: string;
    offers?: string[];
    message?: string;
    headerLogo?: string;
    theme?: string;
    supportMail?: string;
    logo?: string;
    chatRoomDisabled?: boolean;
  };
}

export const Partner: PartnerDetails = {
  [PartnerName.FINO]: {
    name: "Fino Payments Bank Limited",
    companyName: "Fino",
    offers: [
      "Credit upto Rs. 2 lacs",
      "2.5% flat interest per month",
      "Anytime withdrawal",
      "1 day repayment",
      "Money in Fino Account",
    ],
    message:
      "You have successfully submitted your consent to avail credit line service of Ekagrata Finance via MyShubhLife. MyShubhLife team will reach you shortly.",
  },
  [PartnerName.SC_ADVANTAGE_CLUB]: {
    name: "Advantage Club Private Limited",
    companyName: "Advantage Club",
    offers: [
      "Credit up to Rs. 2 lacs",
      "2.5% flat interest per month",
      "1-day disbursement",
      "Money into your bank account",
      "No physical documentation and verification",
    ],
  },
  [PartnerName.SC_EASY_PAY]: {
    name: "EasyPay Private Limited",
    companyName: "EasyPay",
    headerLogo: `${baseImageUrl}/img/logo/easypay-logo.png`,
    theme: "sceasypay-theme",
    supportMail: "customercare@easypay.in",
    chatRoomDisabled: true,
  },
  [PartnerName.SPICEMONEY]: {
    name: "Spice Money Limited",
    offers: [
      "Credit upto Rs. 2 lacs",
      "2.5% flat interest per month",
      "Anytime withdrawal",
      "1 day repayment",
      "Money in Bank Account",
    ],
    logo: `${baseImageUrl}/img/logo/spicemoney-logo.png`,
  },
  [PartnerName.scflipkart]: {
    name: "Flipkart",
    offers: [
      "Term loan upto Rs. 7 lacs",
      "Tenure 3, 6, 9, 12, 15, 18, 21 & 24 months",
      "Money in Bank Account",
    ],
    headerLogo: `${baseImageUrl}/img/logo/flipkart-powered-by-msl.png`,
  },
};
